import style from './Signature.module.scss'
import React, { useEffect, useRef, useState } from 'react'
import getLoginRegistrationIcon from '../../../../../../../assets/imgs/login-form/login-registartion-imgs'
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form'
import { FieldValidatorType } from '../../../../../../utils/Validators/validator'
import 'react-phone-input-2/lib/style.css';
import SignatureCanvas from 'react-signature-canvas';
import { useDispatch } from 'react-redux'
import { change } from 'redux-form';
import save from '../../../../../../../assets/imgs/checkboxes/ch_true_grn_1.png'
import cancel from '../../../../../../../assets/imgs/checkboxes/ch_false_bw_1.svg'


type SignatureProps = {
    input: WrappedFieldInputProps
    meta: WrappedFieldMetaProps
    placeholder: string
    type: string
    validate: Array<FieldValidatorType>
}




const Signature: React.FC<SignatureProps> = (props) => {
    const signatureRef = useRef<SignatureCanvas | null>(null); // Задаем тип для signatureRef
    const [trimmedDataURL, setTrimmedDataURL] = useState<string | null>(null);
    const [isDrawing, setIsDrawing] = useState(false);

    // Синхронизируем состояние с props.input.value
    useEffect(() => {
        if (props.input.value && props.input.value !== trimmedDataURL) {
            setTrimmedDataURL(props.input.value);
        } else if (!props.input.value && trimmedDataURL) {
            setTrimmedDataURL(null);
        }
    }, [props.input.value]);

    let error = null
    let index = 0
    if (props.meta.active || props.input.value) {
        index = 1
    }

    // Показываем ошибку если она есть и поле было затронуто
    const hasError = props.meta.error && props.meta.touched && !props.meta.active;
    if (hasError) {
        error = <span className={style.input__error}>{props.meta.error}</span> 
    }

    const dispatch = useDispatch();
    const handleClear = () => {
        
        if (signatureRef.current && !signatureRef.current.isEmpty()) {
            
            setTrimmedDataURL(null)
            dispatch(change('login', 'signature', null));
            signatureRef.current.clear();

        } else {
            setTrimmedDataURL(null)
            dispatch(change('login', 'signature', null));
        }

    }

    const handleTrim = () => {
        if (signatureRef.current && !signatureRef.current.isEmpty()) {
            console.log('Saving signature...')
            let data = signatureRef.current.getTrimmedCanvas().toDataURL('image/png')
            setTrimmedDataURL(data);
            dispatch(change('login', 'signature', data));
            console.log('Signature saved:', data ? 'yes' : 'no');
        } else {
            console.log('Signature canvas is empty');
        }
    }

    // Обработчики для touch событий на мобильных устройствах
    const handleTouchStart = () => {
        setIsDrawing(true);
    }

    const handleTouchEnd = () => {
        setIsDrawing(false);
        // Небольшая задержка чтобы canvas успел обработать последний touch
        setTimeout(() => {
            handleTrim();
        }, 100);
    }

    return (

        <>
            <div className={style.signature__header}>
                <h3 className={style.signature__title}>{props.placeholder}: {error}</h3> 
            </div>
            <div 
                className={
                    hasError 
                        ? style.signatureError 
                        : trimmedDataURL 
                            ? style.signatureDone 
                            : style.signature
                }
                onMouseLeave={handleTrim}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >

                {<SignatureCanvas

                    ref={signatureRef}
                    canvasProps={{ className:style.canvas }}
                />}
                {trimmedDataURL && <div className={style.signatureResult__wrapper}>
                    {/* <img className={style.signature__result} alt='signature' src={trimmedDataURL} /> */}
                </div>}

                {<input style={{ display: 'none' }} {...props.input} />}
                <div className={trimmedDataURL ? style.signature__optionsDone : style.signature__options}>
                    <div className={style.signature__buttons}>

                        <img onClick={handleClear} className={style.signature__button} src={cancel} />
                        {!trimmedDataURL && <img className={style.signature__button} src={save} onClick={handleTrim} />}
                    </div>



                </div>

            </div>
        </>
    )
}



export default Signature